// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2rTmB","boxTitle":"Qualiphy_boxTitle__1Ru-q","box":"Qualiphy_box__1rLuK","toggleWrap":"Qualiphy_toggleWrap__31FfK"};